import React, { createContext, useContext, useEffect, useState } from "react";

const KeycloakContext = createContext();

export const useKeycloak = () => {
  const context = useContext(KeycloakContext);
  if (!context) {
    throw new Error("Keycloak error");
  }
  return context;
};

export const KeycloakProvider = ({ children }) => {
  const [keycloak, setKeycloak] = useState(null);
  const [userAuthenticated, setUserAuthenticated] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!window.Keycloak) {
      console.error("Keycloak not available");
      setLoading(false);
      return;
    }

    const keycloakConfig = {
      url: process.env.REACT_APP_KEYCLOAK_URL,
      realm: process.env.REACT_APP_KEYCLOAK_REALM,
      clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
    };

    const keycloakInstance = new window.Keycloak(keycloakConfig);

    keycloakInstance
      .init({
        onLoad: "login-required",
        checkLoginIframe: false,
      })
      .then((authenticated) => {
        if (authenticated) {
          setKeycloak(keycloakInstance);
          setUserAuthenticated(true);

          setUserInfo({
            username: keycloakInstance.tokenParsed?.preferred_username,
            email: keycloakInstance.tokenParsed?.email,
            fullName: keycloakInstance.tokenParsed?.name,
            token: keycloakInstance.token,
          });
        } else {
          console.log("User not authenticated");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("keycloak error:", error);
        setLoading(false);
      });
  }, []);

  const getToken = () => {
    return keycloak?.token;
  };

  const refreshToken = () => {
    return keycloak?.updateToken(30);
  };

  const value = {
    keycloak,
    userAuthenticated,
    userInfo,
    loading,
    getToken,
    refreshToken,
  };

  return (
    <KeycloakContext.Provider value={value}>
      {children}
    </KeycloakContext.Provider>
  );
};
